import { creditEndPoint } from '../constants';

export default {
  profileContract: `${creditEndPoint}/get-tnc-doc-url`,
};
